import React, { useState } from "react";
// import axios from "axios";
import godkhaliImage from "../../asset/images/godkhali.jpg";
import { FiMapPin } from "react-icons/fi";
import "./TouristPlace.css";

const VenuAccomodation = () => {
  const staticAccommodations = [
    {
      _id: "tourist-place-1",
      title: "Godkhali – The Capital of Flowers",
      description: `Godkhali is one of the hidden gems of not only Jashore, but of Bangladesh. It is a flower garden so big that it alone has the capacity to meet 60 – 70 per cent of the country's demand for flowers. Spread over 90 villages in the Jhikargacha and Sharsha areas, there is no better place to gaze upon the combination of lavender, white, pink, blue, and yellow stretched till the horizon. Inundated with the sweet fragrance of flowers with beautiful butterflies spotted throughout, it truly is a slice of heaven on Earth. Some variations of cultivation include rose, gladiola, tuberose, and marigold. Flowers are grown, collected and brought to the Godkhali market in bullock carts from where people can purchase. The months of January and February are the best time to visit this place.`,
      imageUrl: godkhaliImage
    }
  ];

  const [accommodations] = useState(staticAccommodations);
   // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchTouristPlaces = async () => {
  //     try => {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/tourist-places`
  //       );
  //       setTouristPlaces(response.data.touristPlaces || []);
  //       setLoading(false);
  //     } catch (error) {
  //       console.error("Error fetching tourist places:", error);
  //       setError("Error loading tourist places information");
  //       setLoading(false);
  //     }
  //   };

  //   fetchTouristPlaces();
  // }, []);

  return (
    <div className="venue-accommodation-container">
      <div className="heading-container">
        <h4>Tourist Places</h4>
      </div>

      <div className="venue-accommodation-content">
        {accommodations.length > 0 ? (
          accommodations.map((accommodation) => (
            <div key={accommodation._id} className="venue-accommodation-layout">
                {/* Left Side - Image and Map */}
                <div className="venue-left-section">
                  {accommodation.imageUrl && (
                    <div className="venue-image-wrapper">
                      <img
                        src={accommodation.imageUrl}
                        alt={accommodation.title}
                        className="venue-image"
                      />
                    </div>
                  )}
                  
                  <div className="venue-map-wrapper">
                    <div className="map-header">
                      <FiMapPin className="map-icon" />
                      <h5>Location Map</h5>
                    </div>
                    <div className="map-container">
                      <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.1044672887865!2d89.05254798029313!3d23.056631325389414!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ff3e5e42a8d48d%3A0xfc29da49e31f09c3!2sGodkhali%20Flower%20Garden!5e0!3m2!1sen!2sbd!4v1766256457785!5m2!1sen!2sbd" 
                        width="100%" 
                        height="100%" 
                        style={{border: 0}} 
                        allowFullScreen="" 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Godkhali Location Map"
                      />
                    </div>
                  </div>
                </div>

                {/* Right Side - Details */}
                <div className="venue-right-section">
                  <div className="venue-details-card">
                    <h3 className="venue-title">{accommodation.title}</h3>
                    <div className="venue-description">
                      <p>{accommodation.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">No accommodation details available</div>
          )}
        </div>
    </div>
  );
};

export default VenuAccomodation;